const r = "__cookiesAccepted";
function l(i) {
  let t = document.cookie.split(";");
  for (let e = 0; e < t.length; e++) {
    let o = t[e].split("=");
    if (i === o[0].trim())
      return o[1];
  }
  return null;
}
function s(i, t, e) {
  let o = "";
  if (e) {
    let n = /* @__PURE__ */ new Date();
    n.setTime(n.getTime() + e * 24 * 60 * 60 * 1e3), o = "; expires=" + n.toUTCString();
  }
  let c = "";
  window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1" && (c = "; domain=.mailslurp.com"), document.cookie = i + "=" + (t || "") + o + "; path=/" + c;
}
function u() {
  return l(r) === "1";
}
function a() {
  s(r, "1", 365);
}
function k() {
  return window.confirm("This action will enable cookies for support purposes.") ? (a(), !0) : !1;
}
export {
  a as acceptCookie,
  k as confirmAcceptCookies,
  l as getCookie,
  u as hasAcceptedCookies,
  s as setCookie
};
